import _ from 'lodash'
import types from './types'
import defaultState from '@/store/modules/improvementIdea/state'
import mutationsHelpers from '@/store/modules/rev/mutationsHelpers.js'
import revSerializer from '@/lib/revSerializer.js'

const mutations = {
  [types.SET_REV](state, { rev }) {
    state.rev = revSerializer.serializeImprovementIdeaForLocalState(
      rev,
      defaultState.rev
    )
  },

  [types.SET_AVAILABLE_OWNERS](state, { results }) {
    state.availableOwners = results.map(mutationsHelpers.formatUser)
  },

  [types.SET_AVAILABLE_COACHES](state, { results }) {
    state.availableCoaches = [...results.map(mutationsHelpers.formatCoach)]
  },

  [types.SET_AVAILABLE_COLLABORATORS](state, { results }) {
    state.availableCollaborators = [...results.map(mutationsHelpers.formatUser)]
  },

  [types.CLEAR_AVAILABLE_COLLABORATORS](state) {
    state.availableCollaborators = []
  },

  [types.SET_REV_CHALLENGES](state, payload) {
    state.challenges = payload.challenges
  },

  updateName(state, name) {
    state.rev.name = name
  },

  setOwner(state, owner) {
    state.rev.team.owner = owner
  },

  setCoach(state, coach) {
    state.rev.team.coach = coach
  },

  setCollaborators(state, collaborators) {
    state.rev.team.collaborators = collaborators
  },

  updateProblem(state, problem) {
    state.rev.relate.problem = problem
  },

  updateIdea(state, idea) {
    state.rev.relate.idea = idea
  },

  updateExpectedResult(state, expectedResult) {
    state.rev.relate.expectedResult = expectedResult
  },

  updateWhatDidYouDo(state, whatDidYouDo) {
    state.rev.experiment.whatDidYouDo = whatDidYouDo
  },

  updateDidExperimentWork(state, didExperimentWork) {
    state.rev.verify.didExperimentWork = didExperimentWork
  },

  updateLearned(state, learned) {
    state.rev.verify.learned = learned
  },

  removeExpandPhoto(state) {
    state.rev.expand.photo = null
  },

  updateSolution(state, solution) {
    state.rev.expand.solution = solution
  },

  updateIsImplemented(state, isImplemented) {
    state.rev.expand.isImplemented = isImplemented
  },

  updateWhyNotImplemented(state, whyNotImplemented) {
    state.rev.expand.whyNotImplemented = whyNotImplemented
  },

  updateLocation(state, location) {
    state.rev.location = {
      organization: location.organization,
      site: location.site,
      tags: location.tags || [],
    }
  },

  updateImpactMetrics(state, metrics) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        impacts: metrics,
      },
    }
  },

  updateInvestments(state, investments) {
    state.rev = {
      ...state.rev,
      reviewPhase: {
        ...state.rev.reviewPhase,
        investments: investments,
      },
    }
  },

  updateStartDate(state, date) {
    state.rev.impactStartsAt = date
  },

  updateEndDate(state, date) {
    state.rev.impactEndsAt = date
  },

  updateCostReduction(state, costReduction) {
    state.rev.review.costReduction = costReduction
  },

  updateInvestment(state, investment) {
    state.rev.review.investment = investment
  },

  updateEstimationComment(state, estimationComment) {
    state.rev.review.estimationComment = estimationComment
  },

  updateRevenue(state, revenue) {
    state.rev.review.revenue = revenue
  },

  updateCategories(state, categories) {
    state.rev.categories = categories
  },

  updatePhase(state, phase) {
    state.rev.phase = phase
  },

  updatePriority(state, priority) {
    state.rev.priority = priority
  },

  updateDueDate(state, date) {
    state.rev.dueDate = date
  },

  updateNotes(state, notes) {
    state.rev.notes = notes
  },

  resetRev(state, rev) {
    state.rev = rev || _.cloneDeep(defaultState.rev)
  },

  setRelateMedia(state, media = []) {
    state.rev.relate = {
      ...state.rev.relate,
      media,
    }
  },

  setExperimentMedia(state, media = []) {
    state.rev.experiment = {
      ...state.rev.experiment,
      media,
    }
  },

  updateTimeInvested(state, timeInvested) {
    state.rev = {
      ...state.rev,
      review: {
        ...state.rev.review,
        timeInvested,
      },
    }
  },

  updateTimeReductionByMonth(state, timeReductionByMonth) {
    state.rev = {
      ...state.rev,
      review: {
        ...state.rev.review,
        timeReductionByMonth,
      },
    }
  },

  setExpandMedia(state, media = []) {
    state.rev.expand = {
      ...state.rev.expand,
      media,
    }
  },
}

export default mutations
